




























import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppRouterLink from '@/components/AppRouterLink.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import { CURRENT_USER } from '@/gql/auth'
import { Common } from '@/mixins'

@Component({
  components: {
    AppRouterLink,
    AppTitleBar
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    reviewableOrderItems: {
      query: gql`query reviewableOrderItems {
        reviewableOrderItems {
          id
          item {
            id
            name
            medias {
              id
              path
            }
            seller {
              id
              username
              shop {
                id
                shoppingMallName
              }
            }
          }
          order {
            id
            createdAt
          }
        }
      }`
    }
  }
})
export default class extends Mixins(Common) {
  reviewableOrderItems = []
}
